<template>
  <div class="logo-box">
    <a class="logo-a" href="/">
      <img src="../assets/images/logo.png" alt="">
    </a>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.logo-box {
  flex: 0 0 auto;
  position: relative;
  display: flex;
  align-items: center;

  .logo-a {
    width: 225px;
    height: 48px;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;

    }
    // background: url(@/assets/images/logo.png);
    // background-repeat: no-repeat;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
